let obj = {};
//意外死亡、伤残险种选项
obj.swcjOptions = [
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  },
  {
    value: 900000,
    name: '90万'
  },
  {
    value: 1000000,
    name: '100万'
  }
];
//意外医疗费用补偿险种
obj.ylfyOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 10000,
    name: '1万'
  },
  {
    value: 20000,
    name: '2万'
  },
  {
    value: 30000,
    name: '3万'
  },
  {
    value: 40000,
    name: '4万'
  },
  {
    value: 50000,
    name: '5万'
  },
  {
    value: 60000,
    name: '6万'
  },
  {
    value: 70000,
    name: '7万'
  },
  {
    value: 80000,
    name: '8万'
  },
  {
    value: 90000,
    name: '9万'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 110000,
    name: '11万'
  },
  {
    value: 120000,
    name: '12万'
  },
  {
    value: 130000,
    name: '13万'
  },
  {
    value: 140000,
    name: '14万'
  },
  {
    value: 150000,
    name: '15万'
  },
  {
    value: 160000,
    name: '16万'
  },
  {
    value: 170000,
    name: '17万'
  },
  {
    value: 180000,
    name: '18万'
  },
  {
    value: 190000,
    name: '19万'
  },
  {
    value: 200000,
    name: '20万'
  }
];
// 基础选项
obj.baseOptions = [
  {
    value: 0,
    name: '不附加'
  }
];
// 职业类别
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  },
  {
    value: '6',
    name: '6类'
  }
];
//意外医疗费用补偿（扩展社保外医疗，100免100%报）
obj.ylfybcBCOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 1000,
    name: '1000'
  },
  {
    value: 2000,
    name: '2000'
  },
  {
    value: 3000,
    name: '3000'
  },
  {
    value: 4000,
    name: '4000'
  },
  {
    value: 5000,
    name: '5000'
  }
];
//性别
obj.sexOptions = [
  {
    name: '男',
    value: 'M'
  },
  {
    name: '女',
    value: 'F'
  }
];
obj.cloccupationNumberList = [
  //超龄投保人数
  {
    occupationKind: '1Exceed',
    occupationKinds: '1',
    occupationName: '1类',
    personNum: 0
  },
  {
    occupationKind: '2Exceed',
    occupationKinds: '2',
    occupationName: '2类',
    personNum: 0
  },
  {
    occupationKind: '3Exceed',
    occupationKinds: '3',
    occupationName: '3类',
    personNum: 0
  },
  {
    occupationKind: '4Exceed',
    occupationKinds: '4',
    occupationName: '4类',
    personNum: 0
  },
  {
    occupationKind: '5Exceed',
    occupationKinds: '5',
    occupationName: '5类',
    personNum: 0
  }
];
//投保人数
obj.occupationNumberList = [
  {
    occupationKind: '1',
    occupationName: '1类',
    personNum: 0
  },
  {
    occupationKind: '2',
    occupationName: '2类',
    personNum: 0
  },
  {
    occupationKind: '3',
    occupationName: '3类',
    personNum: 0
  },
  {
    occupationKind: '4',
    occupationName: '4类',
    personNum: 0
  },
  {
    occupationKind: '5',
    occupationName: '5类',
    personNum: 0
  }
];
//投保期限
obj.guarantPre = [
  {
    key: 1,
    value: '1个月'
  },
  {
    key: 3,
    value: '3个月'
  },
  {
    key: 6,
    value: '6个月'
  },
  {
    key: 12,
    value: '12个月'
  }
];
//表格的头部
obj.columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '姓名',
    dataIndex: 'name'
  },
  {
    title: '证件类型',
    dataIndex: 'idType',
    key: 'idType',
    scopedSlots: { customRender: 'idType' }
  },
  {
    title: '证件号码',
    dataIndex: 'idNumber'
  },
  {
    title: '出生日期',
    dataIndex: 'birthDate'
  },
  {
    title: '性别',
    dataIndex: 'gender',
    key: 'gender',
    scopedSlots: { customRender: 'gender' }
  },
  {
    title: '职业代码',
    dataIndex: 'occupationCode'
  },
  {
    title: '职业名称',
    dataIndex: 'occupationName'
  },
  {
    title: '职业类别',
    dataIndex: 'occulevel',
    key: 'occulevel',
    scopedSlots: { customRender: 'occulevel' }
  }
];
//投保人证件类型
obj.companyIdTypeOptions = [
  {
    value: '01',
    name: '组织机构代码证'
  },
  {
    value: '02',
    name: '税务登记证'
  },
  {
    value: '04',
    name: '工商营业执照'
  }
];
export default { ...obj };
